
import { defineComponent } from "vue";
import { Alert } from "@/commons/types";
import Alerter from "@/components/Alerter.vue";
import { VehicleCreateSchema, VehiclesService } from "@/commons/client";

type Rules = any; // importa il tuo tipo reale se lo hai
type VehicleCreateForm = Pick<VehicleCreateSchema, "vehicle_id" | "plate">;

export default defineComponent({
  name: "VehicleCreateView",

  components: {
    Alerter,
  },

  // CONSIGLIATO: pk come number per evitare parse/NaN
  props: {
    pk: {
      type: Number,
      required: true,
    },
  },

  data(): {
    alerts: Alert[];
    vehicleData: VehicleCreateForm;
  } {
    return {
      alerts: [],
      vehicleData: {
        vehicle_id: "",
        plate: "",
      },
    };
  },

  computed: {
    rules(): Rules {
      const store = (this as any).$store as { state: { genericRules: Rules } };
      return store?.state?.genericRules ?? {};
    },
    organizationPkInt(): number {
      // con pk:number è già un number certo
      return this.pk as number;
    },
  },

  methods: {
    async createVehicle(): Promise<void> {
      try {
        await VehiclesService.organizationVehiclesCreateV1OrganizationsPkVehiclesPost(
          this.organizationPkInt,
          this.vehicleData as VehicleCreateSchema
        );
        this.alerts.push({
          type: "success",
          text: "Veicolo creato con successo",
        });
        this.vehicleData = { vehicle_id: "", plate: "" };
      } catch (err: unknown) {
        const message =
          (err as any)?.body?.detail ||
          (err as Error)?.message ||
          "Errore nella creazione del veicolo";
        this.alerts.push({ type: "error", text: message });
      }
    },
  },
});
